"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipTrigger = exports.TooltipProvider = exports.TooltipPortal = exports.TooltipContent = exports.Tooltip = void 0;
exports.withTooltip = withTooltip;
var _react = _interopRequireDefault(require("react"));
var TooltipPrimitive = _interopRequireWildcard(require("@radix-ui/react-tooltip"));
var _cn = require("@udecode/cn");
var _jsxRuntime = require("react/jsx-runtime");
/* Manually installed do not override */

var TooltipProvider = exports.TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = exports.Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = exports.TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipPortal = exports.TooltipPortal = TooltipPrimitive.Portal;
var TooltipContent = exports.TooltipContent = (0, _cn.withCn)((0, _cn.withProps)(TooltipPrimitive.Content, {
  sideOffset: 4
}), 'z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md');
function withTooltip(Component) {
  return /*#__PURE__*/_react.default.forwardRef(function ExtendComponent(_ref, ref) {
    var tooltip = _ref.tooltip,
      tooltipContentProps = _ref.tooltipContentProps,
      tooltipProps = _ref.tooltipProps,
      props = _objectWithoutProperties(_ref, ["tooltip", "tooltipContentProps", "tooltipProps"]);
    var _react$default$useSta = _react.default.useState(false),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      mounted = _react$default$useSta2[0],
      setMounted = _react$default$useSta2[1];
    _react.default.useEffect(function () {
      setMounted(true);
    }, []);

    // @ts-ignore
    var component = /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, _objectSpread({
      ref: ref
    }, props));
    if (tooltip && mounted) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Tooltip, _objectSpread({}, tooltipProps, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TooltipTrigger, {
          asChild: true,
          children: component
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TooltipPortal, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: 'plate-editor-wrapper',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TooltipContent, _objectSpread({
              style: {
                zIndex: 100000
              }
            }, tooltipContentProps, {
              children: tooltip
            }))
          })
        })]
      }));
    }
    return component;
  });
}